module.exports = __webpack_public_path__ + "html/related-pages_2f38d1c312ba616c55cf15fc94d957c1.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/related-pages.html
// module id = kmnB
// module chunks = 55